// extracted by mini-css-extract-plugin
export default {"productCarousel":"E1-z"};